import { render, staticRenderFns } from "./UsageTermsTable.vue?vue&type=template&id=2eb8dea0&scoped=true"
import script from "./UsageTermsTable.vue?vue&type=script&lang=js"
export * from "./UsageTermsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb8dea0",
  null
  
)

export default component.exports